import { Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { Announcement } from 'components/Announcement'

export const DeprecateTestnetAnnouncement = () => (
  <Announcement>
    <Flex gap={1} flexDir="column" alignItems="center" wrap="wrap">
      <Text style={{ fontWeight: 600 }}>🚨Notice: Legacy Testnet Shutdown Imminent 🚨</Text>
      <Text>
        The legacy testnet will be{' '}
        <Text as="span" style={{ fontWeight: 600 }}>
          shut down at the end of the month.{' '}
        </Text>
        Please{' '}
        <Text as="span" style={{ fontWeight: 600 }}>
          withdraw your Sepolia test ETH{' '}
        </Text>
        as it will no longer be usable. This legacy network has been{' '}
        <Text as="span" style={{ fontWeight: 600 }}>
          replaced by the Garfield testnet.
        </Text>
      </Text>
      <Text>
        We strongly recommend withdrawing now while it’s easy. However, for those who miss the
        window, an{' '}
        <Text as="span" style={{ fontWeight: 600 }}>
          escape hatch{' '}
        </Text>
        will be available{' '}
        <Text as="span" style={{ fontWeight: 600 }}>
          after the sequencer shuts down{' '}
        </Text>
        to allow withdrawals at a later time.
      </Text>
    </Flex>
  </Announcement>
)
